import { css, html } from 'lit'
//import { useEffect } from 'haunted'
import { customElement, property } from 'lit/decorators.js'
import { LitHauntedElement } from '../../mixins/lit-haunted-element';

/**
 * Inspired by: https://developer.apple.com/documentation/swiftui/font/textstyle
 */
export type EPTextStyle = 'body' | 'footnote' | 'caption' | 'headline'
export type EPTextColor = 'black' | 'muted'
export type EPTextFont = 'sans-serif' | 'serif' | 'monospace'

//const embedColor = (color: EPTextColor, fallback: string = '#000000') => `var(--color-${color}, ${fallback})`;
const embedColor2 = (color: string) => `var(--color, var(--color-${color}, #000))`;

@customElement('ep-text')
export class EPText extends LitHauntedElement {

  @property({ attribute: 'font' })
  fontFamily: EPTextFont = 'sans-serif';

  @property({ attribute: 'variant', reflect: false })
  variant: EPTextStyle = 'body'
  
  @property({ attribute: 'color', reflect: false })
  color: EPTextColor = 'black'

  render() {
    return html`
      <ep-contents style="color: ${embedColor2(this.color)}; font-family: var(--font-${this.fontFamily});" class=${`text-style ${this.variant}`}>
        <slot></slot>
      </ep-contents>
    `
  }

  static styles = css`
    :host {
      --font-sans-serif: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
      --font-monospace: ui-monospace, SFMono-Regular, SF Mono, Menlo, "Cascadia Mono", Consolas, Liberation Mono, monospace;
      --color-black: #24292F;
      --color-muted: #656d76;
      /* --color: transparent; */
      display: inline-block;
      font-family: var(--font-prose);
      color: var(--color-fg-muted);
      font-size: 1.0em;
      font-weight: 400;
      line-height: 1.5;
    }

    .text-style.body {
      font-size: 1.0em;
      font-weight: 400;
      font-style: normal;
      line-height: 1.3;
    }

    .text-style.footnote {
      font-size: 0.9em;
      font-weight: 400;
      font-style: normal;
      line-height: 1.3;
    }

    .text-style.caption {
      font-size: 0.85em;
      font-weight: 500;
      font-style: normal;
      line-height: 1.3;
    }

    .text-style.headline {
      font-size: 1.1em;
      font-weight: 500;
      font-style: normal;
      line-height: 1.5;
    }

    * {
      box-sizing: border-box;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-text': EPText
  }
}
